export default "__VITE_ASSET__D4ajr6e9__"